import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Image = ({ alt, classes, src }) => (
  <LazyLoadImage
    alt={alt}
    wrapperClassName={classes.root}
    className={classes.root}
    src={src}
    effect="blur"
  />
);

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  src: PropTypes.string.isRequired,
};

const styles = () => ({
  root: {
    width: '100%',
    height: '100%',
    borderRadius: '8px',
    objectFit: 'cover',
  },
});

export default withStyles(styles)(Image);
